import type {ReactElement} from 'react';
import type {InitialsAvatarProps} from './initials-avatar.types';
import {INITIALS_AVATAR_COLOUR_SLOT_COUNT, InitialsAvatarSize} from './initials-avatar.types';
import styles from './initials-avatar.module.scss';

/**
 * The saved-account avatar: the account's initial on one of three
 * colours. Decorative — the name is always rendered as text beside it — so it is hidden from assistive tech.
 */
export function InitialsAvatar({name, colourSlot, size}: InitialsAvatarProps): ReactElement {
  const getInitial = (): string => {
    const [firstCharacter = ''] = name.trim();
    return firstCharacter.toUpperCase();
  };

  const getSizeClassName = (): string => {
    return size === InitialsAvatarSize.LARGE ? styles.large : styles.small;
  };

  const getColourClassName = (): string => {
    const colourClassNames = [styles.colourSlot0, styles.colourSlot1, styles.colourSlot2];
    return colourClassNames[Math.abs(colourSlot) % INITIALS_AVATAR_COLOUR_SLOT_COUNT];
  };

  return (
    <span aria-hidden className={`${styles.avatar} ${getSizeClassName()} ${getColourClassName()}`}>
      {getInitial()}
    </span>
  );
}
